import type { IdeaStatus } from '@/services/ideasService'

type TimeLabelInput = {
  submitted_at?: string | null
  status?: IdeaStatus
  review_opened_at?: string | null
  review_closed_at?: string | null
  review_duration_days?: number | null
}

/** How long ago the idea was posted (e.g. "Posted 3h ago" / "Posted 5d ago"). */
export function ideaTimeLeftLabel(item: TimeLabelInput): string {
  if (!item.submitted_at) return '—'
  const diff = Date.now() - new Date(item.submitted_at).getTime()
  if (diff < 3_600_000) return 'Posted just now'
  if (diff < 86_400_000) return `Posted ${Math.floor(diff / 3_600_000)}h ago`
  const days = Math.floor(diff / 86_400_000)
  if (days === 1) return 'Posted 1d ago'
  return `Posted ${days}d ago`
}

/** Posted-age is never "urgent" — kept for callers that still style the label. */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function isTimeLeftUrgent(_item: TimeLabelInput): boolean {
  return false
}
